export default "__VITE_ASSET__BSA$nwir__"